document.addEventListener("DOMContentLoaded", function () {
  const sliderContainer = document.querySelector(".slider-container");
  const prevButton = document.querySelector(".slider-button.prev");
  const nextButton = document.querySelector(".slider-button.next");

  let currentIndex = 0;
  const totalSlides = sliderContainer.children.length;
  const slidesPerViewDesktop = parseInt(sliderContainer.dataset.slidesDesktop) || 3;
  const slidesPerViewMobile = parseInt(sliderContainer.dataset.slidesMobile) || 1;
  const slideWidth = sliderContainer.children[0].offsetWidth + 16; // Include gap

  function updateSlider() {
    let slidesPerView = window.innerWidth > 768 ? slidesPerViewDesktop : slidesPerViewMobile;
    const maxIndex = totalSlides - slidesPerView;
    currentIndex = Math.max(0, Math.min(currentIndex, maxIndex));

    sliderContainer.style.transform = `translateX(-${currentIndex * slideWidth}px)`;
  }

  prevButton.addEventListener("click", function () {
    currentIndex--;
    updateSlider();
  });

  nextButton.addEventListener("click", function () {
    currentIndex++;
    updateSlider();
  });

  window.addEventListener("resize", updateSlider);
  updateSlider();
});
